import {
  Badge,
  Box,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
  Stat,
  StatArrow,
  StatGroup,
  StatHelpText,
  StatNumber,
  Table,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
  useColorMode,
} from "@chakra-ui/react";
import React, { useState } from "react";
import ReactPaginate from "react-paginate";

import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";

import { ArrowBackIcon, ArrowForwardIcon, SearchIcon } from "@chakra-ui/icons";
import moment from "moment";
import { useEffect } from "react";
import { FormattedNumber } from "react-intl";
import { useParams } from "react-router-dom";
import AddEvent from "./AddEvent";
import PdfM from "./PdfM";
import ReportEvent from "./ReportEvent";
import "./index.css";

function TableGeral({ eventos, getEvents }) {
  const { colorMode, toggleColorMode } = useColorMode();
  const { carroId, filialId } = useParams();
  const [selectedEvent, setSelectedEvent] = useState(null); // Esta linha cria um estado chamado "selectedEvent" e uma função "setSelectedEvent" para armazenar e atualizar o evento selecionado na tabela.
  const [isModalOpen, setIsModalOpen] = useState(false); // Esta linha cria um estado chamado "isModalOpen" e uma função "setIsModalOpen" para armazenar e atualizar o estado de abertura do modal.
  const [searchTerm, setSearchTerm] = useState(""); //Esta linha cria um estado chamado "searchTerm" e uma função "setSearchTerm" para armazenar e atualizar o termo de busca digitado pelo usuário.
  const [filteredEvents, setFilteredEvents] = useState(eventos.ArrayEvents); //Esta linha cria um estado chamado "filteredEvents" e uma função "setFilteredEvents" para armazenar e atualizar a lista de eventos filtrados de acordo com o termo de busca.
  const [variation, setVariation] = useState(0); //Esta linha cria um estado chamado "variation" e uma função "setVariation" para armazenar e atualizar a variação do valor entre os eventos mais antigos e mais recentes.
  const [currentMonthSpent, setCurrentMonthSpent] = useState(0);
  const [previousMonthSpent, setPreviousMonthSpent] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    carroId, filialId;
  }, [carroId, filialId]);

  //usa o hook useEffect para ordenar os eventos pelo campo "date" e filtrar os eventos de acordo com o termo de busca digitado pelo usuário. Ele compara o termo de busca com os campos "reason", "detalhe_c", "date", "valor" e "resumo" dos eventos e armazena os resultados filtrados no estado "filteredEvents".
  useEffect(() => {
    if (eventos.ArrayEvents) {
      setFilteredEvents(
        eventos.ArrayEvents.sort((a, b) => {
          // aqui você compara as datas dos eventos
          // a data mais antiga vem primeiro, então usamos b - a
          return b.createdAt - a.createdAt;
        }).filter((event) => {
          return (
            event.reason.toLowerCase().includes(searchTerm.toLowerCase()) ||
            moment(event.createdAt.seconds * 1000)
              .format("DD/MM/YYYY HH:mm:ss")
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            moment
              .utc(event.date)
              .format("DD/MM/YYYY")
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            event.criador.toLowerCase().includes(searchTerm.toLowerCase()) ||
            event.valor.toString().includes(searchTerm) ||
            event.resumo.toLowerCase().includes(searchTerm.toLowerCase())
          );
        })
      );
    }
  }, [searchTerm, eventos]);

  // Calcular o valor gasto no mês atual
  useEffect(() => {
    var currentMonth = 0;
    if (eventos && eventos.ArrayEvents) {
      eventos.ArrayEvents.forEach((event) => {
        if (moment.utc(event.date).month() === moment().month()) {
          currentMonth += event.valor;
        }
      });
    }
    setCurrentMonthSpent(currentMonth);
  }, [eventos]);

  // Calcular o valor gasto no mês anterior
  useEffect(() => {
    if (eventos.ArrayEvents) {
      let previousMonth = 0;
      eventos.ArrayEvents.forEach((event) => {
        const eventMoment = moment.utc(event.date);
        const previousMonthStart = moment
          .utc()
          .startOf("month")
          .subtract(1, "months");
        const previousMonthEnd = moment
          .utc()
          .endOf("month")
          .subtract(1, "months");
        if (
          eventMoment.isBetween(
            previousMonthStart,
            previousMonthEnd,
            null,
            "[]"
          )
        ) {
          previousMonth += event.valor;
        }
      });

      setPreviousMonthSpent(previousMonth);
    }
  }, [eventos.ArrayEvents]);

  // Calcular a variação percentual entre os valores gastos no mês atual e no mês anterior
  useEffect(() => {
    if (previousMonthSpent !== 0) {
      setVariation(
        ((currentMonthSpent - previousMonthSpent) / previousMonthSpent) * 100
      );
    }
  }, [currentMonthSpent, previousMonthSpent]);

  const getItemsToShow = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    if (filteredEvents) {
      return filteredEvents.slice(startIndex, endIndex);
    } else {
      return [];
    }
  };

  const itemsToShow = getItemsToShow();

  let pageCount;
  if (filteredEvents) {
    pageCount = Math.ceil(filteredEvents.length / itemsPerPage);
  } else {
    pageCount = 1;
  }

  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1;
    setCurrentPage(selectedPage);
  };

  const CustomPreviousButton = ({ onClick, disabled }) => (
    <Button
      leftIcon={<ArrowBackIcon />}
      colorScheme="blue"
      size="sm"
      onClick={onClick}
      disabled={disabled}
      _hover={{ bg: "blue.700" }}
      _active={{ bg: "blue.700" }}
    >
      Voltar
    </Button>
  );

  const CustomNextButton = ({ onClick, disabled }) => (
    <Button
      rightIcon={<ArrowForwardIcon />}
      colorScheme="blue"
      size="sm"
      onClick={onClick}
      disabled={disabled}
      _hover={{ bg: "blue.700" }}
      _active={{ bg: "blue.700" }}
    >
      Próximo
    </Button>
  );

  return (
    <>
      <SimpleGrid
        spacing={2}
        templateColumns="repeat(auto-fill, minmax(300px, 465px))"
        justifyContent="center"
      >
        <Card size="sm">
          {/* <CardHeader>
            <Heading size="md"> Total gasto pelo carro</Heading>
          </CardHeader> */}
          <CardBody>
            <StatGroup>
              <Stat>
                <StatNumber>
                  <Heading size="md"> Total gasto pelo carro</Heading>
                  <FormattedNumber
                    style="currency"
                    currency="BRL"
                    value={
                      eventos.ArrayEvents
                        ? eventos.ArrayEvents.reduce(
                            (acc, event) =>
                              typeof event.valor === "string"
                                ? acc + event.valor
                                : acc + event.valor,
                            0
                          )
                        : 0
                    }
                  ></FormattedNumber>
                </StatNumber>
              </Stat>
            </StatGroup>
          </CardBody>
        </Card>

        <Card size="sm">
          <CardBody>
            <StatGroup>
              <Stat>
                <StatNumber>
                  <Heading size="md">Esse mês</Heading>
                  <FormattedNumber
                    style="currency"
                    currency="BRL"
                    value={currentMonthSpent}
                  ></FormattedNumber>
                </StatNumber>
                <StatHelpText>
                  <StatArrow type={variation >= 0 ? "increase" : "decrease"} />
                  {Math.abs(variation).toFixed(2)}%
                  <Text>
                    {variation >= 0
                      ? `de aumento em comparação ao mês de ${moment()
                          .subtract(1, "months")
                          .format("MMMM")} `
                      : `de redução em comparação ao mês de ${moment()
                          .subtract(1, "months")
                          .format("MMMM")}  `}
                  </Text>
                </StatHelpText>
                <StatNumber mt={3}>
                  <Text fontSize="sm">
                    mês anterior (
                    {moment().subtract(1, "months").format("MMMM")} )
                  </Text>

                  <FormattedNumber
                    style="currency"
                    currency="BRL"
                    value={previousMonthSpent}
                  ></FormattedNumber>
                </StatNumber>
              </Stat>
            </StatGroup>
          </CardBody>
        </Card>

        {/* <Card>
          <ChartCar dados={eventos} />
        </Card> */}
      </SimpleGrid>

      <Flex justify="flex-end" pt={2}>
        <Box overflowX="auto">
          <ButtonGroup>
            <ReportEvent
              filteredEvents={filteredEvents}
              carroId={carroId}
              filialId={filialId}
            />
            <PdfM
              filteredEvents={filteredEvents}
              carroId={carroId}
              filialId={filialId}
            />
            <AddEvent getEvents={getEvents} />
          </ButtonGroup>
        </Box>
      </Flex>
      <InputGroup mb={3} mt={3}>
        <InputLeftElement
          pointerEvents="none"
          children={<SearchIcon color="gray.300" />}
        />
        <Input
          type="text"
          placeholder="Pesquise aqui por Motivo, Detalhes, Data, Usuário, Valor ou Resumo"
          variant="filled"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </InputGroup>

      <ReactPaginate
        pageCount={pageCount}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        onPageChange={handlePageClick}
        activeClassName={"active"}
        forcePage={currentPage - 1}
        breakLabel="..."
        previousLabel={<CustomPreviousButton />}
        nextLabel={<CustomNextButton />}
        renderOnZeroPageCount={null}
        containerClassName={"pagination"}
        pageLinkClassName={"page"}
        previousLinkClassName={"previous"}
        nextLinkClassName={"next"}
      />
      <Box overflowX="auto">
        {filteredEvents ? (
          <Table variant="striped">
            <Thead>
              <Tr>
                <Th>Motivo</Th>
                <Th>Resumo</Th>
                <Th>Lançado no sistema</Th>
                <Th>Data do Evento</Th>
                <Th>Usuário</Th>
                <Th>Valor</Th>
                <Th>AÇÕES</Th>
              </Tr>
            </Thead>

            <Tbody>
              {itemsToShow
                ? itemsToShow.map((event, index) => (
                    <Tr key={index}>
                      <Td>{event.reason}</Td>
                      <Td
                        className="ellipsis"
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "300px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {event.resumo ? event.resumo : "não informado"}
                      </Td>
                      <Td>
                        {event.createdAt
                          ? moment(event.createdAt.seconds * 1000).format(
                              "DD/MM/YYYY HH:mm:ss"
                            )
                          : "não informada"}
                      </Td>
                      <Td>
                        {moment.utc(event.date).locale("pt-br").format("L")}
                      </Td>
                      <Td>
                        <Badge colorScheme="blue">
                          {event.criador ? event.criador : "não informado"}
                        </Badge>
                      </Td>
                      <Td>
                        <FormattedNumber
                          style="currency"
                          currency="BRL"
                          value={event.valor}
                        />
                      </Td>
                      <Td>
                        <Button
                          colorScheme="blue"
                          onClick={() => {
                            setSelectedEvent(event);
                            setIsModalOpen(true);
                          }}
                        >
                          Ver
                        </Button>
                      </Td>
                    </Tr>
                  ))
                : null}
            </Tbody>
            <Tfoot>
              <Tr>
                <Th>Motivo</Th>
                <Th>Resumo</Th>
                <Th>Lançado no sistema</Th>
                <Th>Data do Evento</Th>
                <Th>Usuário</Th>
                <Th>Valor</Th>
                <Th>AÇÕES</Th>
              </Tr>
            </Tfoot>
          </Table>
        ) : (
          <Flex justifyContent={"center"}>
            <Text pt={10}>
              Ainda não existem eventos cadastrados nesse carro, clique em
              Adicionar Evento para criar.
            </Text>
          </Flex>
        )}
      </Box>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        isCentered
        size="lg"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader borderBottomWidth="1px">Resumo do Evento</ModalHeader>

          <ModalCloseButton />
          <ModalBody>
            {selectedEvent ? (
              <Box mt={2}>
                <Text fontWeight="bold">MOTIVO:</Text> {selectedEvent.reason}
              </Box>
            ) : null}

            {selectedEvent && selectedEvent.detalhe_c ? (
              <Box mt={2}>
                <Text fontWeight="bold">DETALHE:</Text>
                {selectedEvent.detalhe_c}
              </Box>
            ) : null}

            {selectedEvent ? (
              <Box mt={2}>
                <Text fontWeight="bold">DATA DO EVENTO:</Text>
                {moment(selectedEvent.date).locale("pt-br").format("L")}{" "}
              </Box>
            ) : null}

            {selectedEvent ? (
              <Box mt={2}>
                <Text fontWeight="bold">REGISTRADO NO SISTEMA EM:</Text>
                {moment(selectedEvent.createdAt.seconds * 1000).format(
                  "DD/MM/YYYY HH:mm:ss"
                )}
              </Box>
            ) : null}

            {selectedEvent ? (
              <Box mt={2}>
                <Text fontWeight="bold">VALOR:</Text>
                <FormattedNumber
                  style="currency"
                  currency="BRL"
                  value={selectedEvent.valor}
                />
              </Box>
            ) : null}

            {selectedEvent ? (
              <Box mt={2}>
                <Text fontWeight="bold">RESUMO:</Text>
                {selectedEvent.resumo}
              </Box>
            ) : null}

            {selectedEvent ? (
              <Box mt={2}>
                <Text fontWeight="bold">FEITO POR:</Text>
                {selectedEvent.criador}
              </Box>
            ) : null}

            {selectedEvent ? (
              <Box mt={2}>
                <Text fontWeight="bold">ID DO CRIADOR:</Text>
                {selectedEvent.uidcriador}
              </Box>
            ) : null}
          </ModalBody>
        </ModalContent>
      </Modal>

      <ReactPaginate
        pageCount={pageCount}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        onPageChange={handlePageClick}
        activeClassName={"active"}
        forcePage={currentPage - 1}
        breakLabel="..."
        previousLabel={<CustomPreviousButton />}
        nextLabel={<CustomNextButton />}
        renderOnZeroPageCount={null}
        containerClassName={"pagination"}
        pageLinkClassName={"page"}
        previousLinkClassName={"previous"}
        nextLinkClassName={"next"}
      />
    </>
  );
}

export default TableGeral;
